import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFilterActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-label="FilterActive"
    {...props}
  >
    <path
      fill="#DBE6FC"
      fillRule="evenodd"
      d="M16.667 5.101c0-.976-.792-1.768-1.768-1.768H5.1a1.768 1.768 0 0 0-1.25 3.018l3.063 3.063A2 2 0 0 1 7.5 10.83v5.144a.5.5 0 0 0 .658.475l4-1.334a.5.5 0 0 0 .342-.474V10.83a2 2 0 0 1 .586-1.415l3.063-3.063c.331-.331.518-.78.518-1.25Z"
      clipRule="evenodd"
    />
    <path
      fill="#256CF7"
      d="m8.158 16.448-.237-.712zm4-1.334.237.712zm3.99-8.763-.53-.53zM6.915 9.414l-.53.53zM3.851 6.351l-.53.53zm1.25-2.268H14.9v-1.5H5.1v1.5Zm2.344 4.801L4.38 5.821l-1.06 1.06 3.063 3.064 1.06-1.061Zm-.695 1.945v5.144h1.5V10.83zm0 5.144a1.25 1.25 0 0 0 1.645 1.186l-.474-1.423a.25.25 0 0 1 .329.237zm1.645 1.186 4-1.333-.474-1.423-4 1.333zm4-1.333c.51-.17.855-.648.855-1.186h-1.5a.25.25 0 0 1 .17-.237zm.855-1.186v-3.811h-1.5v3.81h1.5Zm2.368-8.82-3.063 3.064 1.061 1.06 3.063-3.062zm1.061 1.062a2.52 2.52 0 0 0 .738-1.78h-1.5c0 .27-.108.528-.299.719l1.061 1.06Zm-3.429 3.947c0-.332.132-.65.366-.884l-1.06-1.061a2.75 2.75 0 0 0-.806 1.945zm-6.866-.884c.234.234.366.552.366.884h1.5c0-.73-.29-1.43-.805-1.945l-1.061 1.06ZM2.584 5.1c0 .668.265 1.308.737 1.78l1.06-1.06a1.02 1.02 0 0 1-.298-.72zm12.315-1.018c.562 0 1.018.456 1.018 1.018h1.5a2.52 2.52 0 0 0-2.518-2.518zM5.1 2.583a2.52 2.52 0 0 0-2.518 2.518h1.5c0-.562.456-1.018 1.018-1.018z"
    />
  </svg>
);
export default SvgFilterActive;
